export const LOGIN_WITH_OAUTH_LOADING = 'LOGIN_WITH_OAUTH_LOADING';
export const LOGIN_WITH_OAUTH_SUCCESS = 'LOGIN_WITH_OAUTH_SUCCESS';
export const LOGIN_WITH_OAUTH_FAIL = 'LOGIN_WITH_OAUTH_FAIL';

export const SEND_WHATSAPP_TOKEN_LOADING = 'SEND_WHATSAPP_TOKEN_LOADING';
export const SEND_WHATSAPP_TOKEN_SUCCESS = 'SEND_WHATSAPP_TOKEN_SUCCESS';
export const SEND_WHATSAPP_TOKEN_FAIL = 'SEND_WHATSAPP_TOKEN_FAIL';

export const LOGIN_WITH_WHATSAPP_LOADING = 'LOGIN_WITH_WHATSAPP_LOADING';
export const LOGIN_WITH_WHATSAPP_SUCCESS = 'LOGIN_WITH_WHATSAPP_SUCCESS';
export const LOGIN_WITH_WHATSAPP_FAIL = 'LOGIN_WITH_WHATSAPP_FAIL';

export const LOGIN_WITH_TOKEN_LOADING = 'LOGIN_WITH_TOKEN_LOADING';
export const LOGIN_WITH_TOKEN_SUCCESS = 'LOGIN_WITH_TOKEN_SUCCESS';
export const LOGIN_WITH_TOKEN_FAIL = 'LOGIN_WITH_TOKEN_FAIL';

export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

export const ME_LOADING = 'ME_LOADING';
export const ME_SUCCESS = 'ME_SUCCESS';
export const ME_FAIL = 'ME_FAIL';

export const GET_FEATURE = 'GET_FEATURE';
export const GET_PROFILE = 'GET_PROFILE';

export const GET_FORMS_LOADING = 'GET_FORMS_LOADING';
export const GET_FORMS_SUCCESS = 'GET_FORMS_SUCCESS';
export const GET_FORMS_FAIL = 'GET_FORMS_FAIL';

export const GET_FORM_LOADING = 'GET_FORM_LOADING';
export const GET_FORM_SUCCESS = 'GET_FORM_SUCCESS';
export const GET_FORM_FAIL = 'GET_FORM_FAIL';

export const GET_GOOGLE_FORMS_LOADING = 'GET_GOOGLE_FORMS_LOADING';
export const GET_GOOGLE_FORMS_SUCCESS = 'GET_GOOGLE_FORMS_SUCCESS';
export const GET_GOOGLE_FORMS_FAIL = 'GET_GOOGLE_FORMS_FAIL';

export const GET_ANALYTICS_LOADING = 'GET_ANALYTICS_LOADING';
export const GET_ANALYTICS_SUCCESS = 'GET_ANALYTICS_SUCCESS';
export const GET_ANALYTICS_FAIL = 'GET_ANALYTICS_FAIL';

export const EDIT_ANALYTICS_LOADING = 'EDIT_ANALYTICS_LOADING';
export const EDIT_ANALYTICS_SUCCESS = 'EDIT_ANALYTICS_SUCCESS';
export const EDIT_ANALYTICS_FAIL = 'EDIT_ANALYTICS_FAIL';

export const ADD_FORM_LOADING = 'ADD_FORM_LOADING';
export const ADD_FORM_SUCCESS = 'ADD_FORM_SUCCESS';
export const ADD_FORM_FAIL = 'ADD_FORM_FAIL';

export const DELETE_FORM_LOADING = 'DELETE_FORM_LOADING';
export const DELETE_FORM_SUCCESS = 'DELETE_FORM_SUCCESS';
export const DELETE_FORM_FAIL = 'DELETE_FORM_FAIL';

export const EDIT_FORM_LOADING = 'EDIT_FORM_LOADING';
export const EDIT_FORM_SUCCESS = 'EDIT_FORM_SUCCESS';
export const EDIT_FORM_FAIL = 'EDIT_FORM_FAIL';
export const CLEAR_FORM_ERROR = 'CLEAR_FORM_ERROR';

export const CONVERT_GFORM_LOADING = 'CONVERT_GFORM_LOADING';
export const CONVERT_GFORM_SUCCESS = 'CONVERT_GFORM_SUCCESS';
export const CONVERT_GFORM_FAIL = 'CONVERT_GFORM_FAIL';

export const GET_PROFILE_LOADING = 'GET_PROFILE_LOADING';
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';
export const GET_PROFILE_FAIL = 'GET_PROFILE_FAIL';

export const EDIT_USER_LOADING = 'EDIT_USER_LOADING';
export const EDIT_USER_SUCCESS = 'EDIT_USER_SUCCESS';
export const EDIT_USER_FAIL = 'EDIT_USER_FAIL';

export const DELETE_USER_LOADING = 'DELETE_USER_LOADING';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAIL = 'DELETE_USER_FAIL';

export const UPDATE_QUESTION_LOADING = 'UPDATE_QUESTION_LOADING';
export const UPDATE_QUESTION_SUCCESS = 'UPDATE_QUESTION_SUCCESS';
export const UPDATE_QUESTION_FAIL = 'UPDATE_QUESTION_FAIL';

export const PUBLISH_FORM_LOADING = 'PUBLISH_FORM_LOADING';
export const PUBLISH_FORM_SUCCESS = 'PUBLISH_FORM_SUCCESS';
export const PUBLISH_FORM_FAIL = 'PUBLISH_FORM_FAIL';

export const SET_SHARE_FORM = 'SET_SHARE_FORM';
export const CLEAR_SHARE_FORM = 'CLEAR_SHARE_FORM';

export const SET_DUPLICATE_FIELD_ERROR = 'SET_DUPLICATE_FIELD_ERROR';
export const REMOVE_DUPLICATE_FIELD_ERROR = 'REMOVE_DUPLICATE_FIELD_ERROR';

export const CHANGE_LANGUAGE_LOADING = 'CHANGE_LANGUAGE_LOADING';
export const CHANGE_LANGUAGE_SUCCESS = 'CHANGE_LANGUAGE_SUCCESS';
export const CHANGE_LANGUAGE_FAIL = 'CHANGE_LANGUAGE_FAIL';

export const PAYMENT_SESSION_LOADING = 'PAYMENT_SESSION_LOADING';
export const PAYMENT_SESSION_SUCCESS = 'PAYMENT_SESSION_SUCCESS';
export const PAYMENT_SESSION_FAIL = 'PAYMENT_SESSION_FAIL';

export const RESPONSE_LOADING = 'RESPONSE_LOADING';
export const RESPONSE_SUCCESS = 'RESPONSE_SUCCESS';
export const RESPONSE_FAIL = 'RESPONSE_FAIL';

export const EXPORT_RESPONSE_LOADING = 'EXPORT_RESPONSE_LOADING';
export const EXPORT_RESPONSE_SUCCESS = 'EXPORT_RESPONSE_SUCCESS';
export const EXPORT_RESPONSE_FAIL = 'EXPORT_RESPONSE_FAIL';

export const OPEN_SEND_TO_WHATSAPP_MODAL = 'OPEN_SEND_TO_WHATSAPP_MODAL';
export const CLOSE_SEND_TO_WHATSAPP_MODAL = 'CLOSE_SEND_TO_WHATSAPP_MODAL';

export const PAYMENT_UPSELL_SHOW = 'PAYMENT_UPSELL_SHOW';
export const PAYMENT_UPSELL_HIDE = 'PAYMENT_UPSELL_HIDE';

export const PAYMENT_UPSELL_TRIGGER = 'PAYMENT_UPSELL_TRIGGER';

export const PIN_FORM_LOADING = 'PIN_FORM_LOADING';
export const PIN_FORM_SUCCESS = 'PIN_FORM_SUCCESS';
export const PIN_FORM_FAIL = 'PIN_FORM_FAIL';
